import { openTelegramLink } from "@telegram-apps/sdk-react";

import { onlyNumbers } from "@/utils/helpers";

type TelegramContact = {
  username?: string | null;
  phone_number?: string | null;
} | null;

export const isTelegramWebApp = (): boolean => {
  const w = window as { Telegram?: { WebApp?: { initData?: string } } };
  return Boolean(w.Telegram?.WebApp && w.Telegram.WebApp.initData?.length);
};

/**
 * Открывает t.me-ссылку.
 *
 * Внутри Telegram нужен нативный `openTelegramLink`: `window.open` из мини-аппа
 * уводит ссылку во внешний браузер, а на мобильных клиентах часто гасится
 * совсем — чат при этом не открывается и кнопка выглядит нерабочей.
 *
 * В браузере окружение Telegram подменено `mockTelegramEnv`, поэтому SDK
 * считает метод доступным, но событие уходит в мок и ничего не открывает —
 * там нужен обычный `window.open`.
 */
export const openTelegramUrl = (url: string) => {
  if (isTelegramWebApp()) {
    try {
      if (openTelegramLink.isAvailable()) {
        openTelegramLink(url);
        return;
      }
    } catch (error) {
      console.error(error);
    }
  }

  window.open(url, "_blank");
};

/**
 * Ссылка на личный чат с рефералом: ник, иначе номер телефона.
 *
 * Телефон приходит так, как его ввёл сам пользователь при регистрации — со
 * скобками, пробелами и через 8, — поэтому в ссылку он идёт только цифрами и в
 * формате `t.me/+<номер>`. Российскую восьмёрку меняем на 7.
 *
 * `text` — предзаполненное сообщение; пустой параметр в ссылку не добавляем.
 */
export const telegramChatLink = (
  contact: TelegramContact,
  text: string = "",
): string | null => {
  const query = text ? `?text=${encodeURIComponent(text)}` : "";

  if (contact?.username) return `https://t.me/${contact.username}${query}`;

  const digits = onlyNumbers(contact?.phone_number ?? "");
  const phone =
    digits.length === 11 && digits.startsWith("8")
      ? `7${digits.slice(1)}`
      : digits;

  if (phone.length >= 10) return `https://t.me/+${phone}${query}`;

  return null;
};
